<div>
  <div class="row col-12">
    <div class="col-12 d-flex justify-content-center"></div>
    <h3 class="first col-12  m-b-md" #messageContainer></h3>
    <ng-container *ngIf="taskLoaded()">
      <div class="col-12 m-b-md">
        <button *ngIf="task.work.notificacionid" appNoDblClick type="button" class="btn btn-sm btn-primary"
          title="{{'Communications.actions.view'|translate}}" (click)="viewCommunicationDetail()" showDelay="1000">
          <i class="far fa-eye" aria-hidden="true"></i><span class="d-none d-sm-inline">
            {{'Communications.actions.view'|translate}}</span>
        </button>
        <button *ngIf="task.work.uuidDoc" appNoDblClick type="button" class="btn btn-sm btn-primary"
          title="{{'DocumentsAction.view'|translate}}" (click)="viewDocument()" showDelay="1000">
          <i class="far fa-eye" aria-hidden="true"></i><span class="d-none d-sm-inline">
            {{'DocumentsAction.view'|translate}}</span>
        </button>
      </div>
      <div class="col-12" *ngIf="optionsAvailable()">
        <ng-container *ngFor="let option of task.work.options; let i = index ">
          <ng-container *ngIf="task.work.multipleSelectedValues">
            <div class="col-12 alert alert-info" (click)="selectOp(option.key)" style="  cursor: pointer;">
              <p-checkbox value="{{option.key}}" [(ngModel)]="task.work.selectedOptions" label="{{option.value}}"
                [ngModelOptions]="{ standalone: true }" class="col-12"></p-checkbox>
            </div>
          </ng-container>
          <ng-container *ngIf="!task.work.multipleSelectedValues">
            <div class="col-12 alert alert-info" (click)="selectOp(option.key)" style="  cursor: pointer;">
              <i class="fa fa-info-circle text text-info m-l-sm float-right p-2" style="cursor:pointer;"
                aria-hidden="true"
                (click)="showInfo((this.task.work.tooltips&&this.task.work.tooltips[i])?this.task.work.tooltips[i].value:'')"
                appNoDblClick
                *ngIf="this.task.work.tooltips&&this.task.work.tooltips[i]&&this.task.work.tooltips[i]?.value.trim()!=''"></i>
              <p-radioButton name="optionsRadios" value="{{option.key}}" label="{{option.value}}"
                [(ngModel)]="task.work.selectedOption" inputId="{{option.key}}"
                class="p-1 d-inline-block font-weight-bold">
              </p-radioButton>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </ng-container>
    <!--span class="col-12 font-bold">Opción seleccionada: {{task.work.selectedOption||'none'}}</span-->
  </div>
</div>